<template>
  <div :class="['common-inner-card', { 'disabled-card': disabled }]">
    <div class="flex-center-start">
      <!-- 商品图片 -->
      <img v-if="imgUrl" class="product-img" :src="imgUrl" alt="" />
      <div class="column-start-center suit-content">
        <div class="inner-title">商品套装</div>
        <div class="product-desc">
          <!-- 商品名称 -->
          共{{ suit_list.length }}件：{{ productDesc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pic_url: {
      type: Array,
      default: () => {
        return [];
      },
    },
    suit_list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imgUrl() {
      if (this.pic_url?.length > 0) {
        return this.pic_url[0];
      } else {
        return "";
      }
    },
    productDesc() {
      if (this.suit_list?.length > 0) {
        return this.suit_list.map((item) => item.name).join("，");
      } else {
        return "";
      }
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
.common-inner-card {
  padding: 8px !important;
}
.inner-title {
  font-size: 15px !important;
}
.product-img {
  border-radius: 12px;
  width: 60px;
  height: 60px;
  margin-right: 12px;
  object-fit: contain;
}
.suit-content {
  height: 60px;
}
.product-desc {
  .inner-desc;
  .ellipsis-two;
  max-width: 200px;
  margin-top: 2px;
}
.disabled-card {
  .product-img {
    opacity: 0.6;
  }
  .product-desc {
    color: #adadad;
  }
}
</style>
